var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66732 0.332031C8.77189 0.332031 9.66732 1.22746 9.66732 2.33203V11.6654C9.66732 12.7699 8.77189 13.6654 7.66732 13.6654H2.33398C1.22941 13.6654 0.333984 12.7699 0.333984 11.6654V2.33203C0.333984 1.22746 1.22941 0.332031 2.33398 0.332031H7.66732ZM7.66732 1.66536H2.33398C1.96579 1.66536 1.66732 1.96384 1.66732 2.33203V11.6654C1.66732 12.0336 1.96579 12.332 2.33398 12.332H7.66732C8.03551 12.332 8.33398 12.0336 8.33398 11.6654V2.33203C8.33398 1.96384 8.03551 1.66536 7.66732 1.66536ZM5.00065 9.66537C5.36884 9.66537 5.66732 9.96384 5.66732 10.332C5.66732 10.7002 5.36884 10.9987 5.00065 10.9987C4.63246 10.9987 4.33398 10.7002 4.33398 10.332C4.33398 9.96384 4.63246 9.66537 5.00065 9.66537Z",
    fill: "#292F49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.af9a7965c51b77c9a595d89e43c49797.svg";
export { ForwardRef as ReactComponent };